import { zodResolver } from '@hookform/resolvers/zod';
import type { PropsWithChildren } from '@shared/utils';
import { useMemo } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { useUpdateItemSetQuestionConditions } from '../update-item-set-question-conditions-provider';

import {
  UpdateItemSetQuestionConditionsSchema,
  type UpdateItemSetQuestionConditionsFormInput,
} from './schema';
import { getDefaultValuesForItemSetQuestionConditionsForm } from './utils';

export default function UpdateItemSetQuestionConditionsFormProvider(
  props: Readonly<PropsWithChildren>,
) {
  const { children } = props;

  const {
    questionTypeStructureId,
    structures,
    levelItemsWithLevel,
    checkExistOnStructures,
    chapterData,
  } = useUpdateItemSetQuestionConditions();

  const defaultValues = useMemo(
    () =>
      getDefaultValuesForItemSetQuestionConditionsForm({
        questionTypeStructureId,
        structures,
        levelItemsWithLevel,
        checkExistOnStructures,
        chapterData,
      }),
    [questionTypeStructureId, structures, levelItemsWithLevel, checkExistOnStructures, chapterData],
  );

  const formContext = useForm<UpdateItemSetQuestionConditionsFormInput>({
    resolver: zodResolver(UpdateItemSetQuestionConditionsSchema),
    defaultValues,
  });

  return <FormProvider {...formContext}>{children}</FormProvider>;
}
